import type { ResolvedAssetStyle } from 'fym-shared/src/music24/assetStyles';
import type { StudioThemeId } from 'fym-shared/src/music24/studioThemes';
import { isKitCardAssetType } from 'fym-shared/src/music24/story/kitCard';

/**
 * True when step 3 of an image has a choice to make: the style tiles, the moment tiles or the
 * lyric line panel. The kit cards (banners, the thumbnail, the link preview) have none: code lays
 * them out in the frame of the theme and the render ignores the style. The cover sizes have no
 * style. With no choice, step 3 drops the two columns and the rail takes the full width. Pure.
 */
export function imageHasOptions(themeId: StudioThemeId, style: ResolvedAssetStyle | null): boolean {
  if (themeId === 'story' || themeId === 'feedPost' || themeId === 'lyricCard') {
    return true;
  }
  return style !== null && !isKitCardAssetType(themeId);
}
